import React, { useEffect } from 'react';
import { X, Check } from 'lucide-react';

export default function ImageLightbox({ imageUrl, title, outcomes = [], onClose }) {
  useEffect(() => {
    const onEsc = (e) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', onEsc);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onEsc);
      document.body.style.overflow = '';
    };
  }, [onClose]);

  if (!imageUrl) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/85 backdrop-blur-sm p-4 md:p-8" onClick={onClose} data-testid="image-lightbox">
      <div className="relative w-full max-w-5xl overflow-hidden rounded-2xl bg-white shadow-2xl" onClick={(e) => e.stopPropagation()}>
        <button aria-label="Close" onClick={onClose} data-testid="image-lightbox-close" className="absolute right-4 top-4 z-10 grid h-9 w-9 place-items-center rounded-full bg-white/95 text-navy shadow-soft hover:bg-white transition-colors">
          <X className="h-5 w-5" />
        </button>

        <div className="relative aspect-[16/9] bg-black">
          <img src={imageUrl} alt={title} className="absolute inset-0 h-full w-full object-cover" />
        </div>

        <div className="p-6 md:p-8">
          <div className="text-[11.5px] font-bold tracking-[0.14em] text-purple">MODULE</div>
          <h3 className="mt-1 text-[22px] md:text-[26px] font-extrabold text-navy leading-tight">{title}</h3>

          {outcomes && outcomes.length > 0 && (
            <>
              <div className="mt-5 text-[11.5px] font-bold tracking-[0.14em] text-mint">LEARNING OUTCOMES</div>
              <ul className="mt-3 space-y-2.5">
                {outcomes.slice(0, 3).map((o, i) => (
                  <li key={i} className="flex items-start gap-3 text-[14px] text-ink-700 leading-relaxed">
                    <span className="mt-0.5 grid h-5 w-5 flex-none place-items-center rounded-full bg-mint-50 text-mint"><Check className="h-3 w-3" strokeWidth={3} /></span>
                    <span>{o}</span>
                  </li>
                ))}
              </ul>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
